import React from 'react';

interface LogoProps {
  className?: string;
  withText?: boolean;
  size?: number;
}

export const Logo: React.FC<LogoProps> = ({ className = '', withText = true, size = 32 }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <rect width="40" height="40" rx="10" fill="#36CCD8"/>
        <path d="M20 8L6 22L12 28L20 20L28 28L34 22L20 8Z" fill="white"/>
        <path d="M20 16L12 24L16 28L20 24L24 28L28 24L20 16Z" fill="white" fillOpacity="0.4"/>
      </svg>
      {withText && <span className="font-bold text-xl tracking-tight text-[var(--v-text-primary)]">Vecindus</span>}
    </div>
  );
};
